import initialState from "app/initialState";
import { ReducerBase } from "common/reducer";
import { Alert } from "domain/alert";
import { ErrorAlertsLoaded } from "./alerts.actions";

export default class AlertsReducer extends ReducerBase<Alert[]> {

    constructor() {
        super();
        this.addHandler(ErrorAlertsLoaded.EventName, this.handleErrorAlertsLoaded);
    }

    handleErrorAlertsLoaded(state: Alert[] = initialState.errorAlerts, event: ErrorAlertsLoaded): Alert[] {
        return event.alerts;
    }

    handleDefault(state: Alert[] = initialState.errorAlerts): Alert[] {
        return state;
    }
} 